import { useState, useEffect } from "react";
import { dashboardAPI } from "../services/api";

// Custom hook for fetching dashboard data (role-based)
export const useDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userRole = localStorage.getItem("user_role");

  const fetchDashboardData = async () => {
    setLoading(true);
    setError(null);
    try {
      let response;

      // Use different endpoints based on user role
      if (userRole === "Admin") {
        response = await dashboardAPI.getDashboardData();
      } else if (userRole === "Annotator" || userRole === "Reviewer") {
        response = await dashboardAPI.getUserDashboard();
      } else {
        throw new Error("Unauthorized access");
      }

      setDashboardData(response);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching dashboard data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userRole) {
      fetchDashboardData();
    }
  }, [userRole]);

  return {
    dashboardData,
    loading,
    error,
    refetch: fetchDashboardData,
  };
};
